
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Mumbaidarshancabs() {



    const cardData =
    {
        keyword: ' Mumbai Darshan Cabs',
        heading: 'Prince Cabs: Mumbai Darshan Cabs',
        headingDescription: 'Prince Cabs offers comfortable and affordable Mumbai Darshan Cabs, perfect for sightseeing tours, family outings, and group travel. Our fleet of well-maintained sedans, SUVs, and luxury cars ensures a safe and enjoyable journey while exploring iconic attractions like Gateway of India, Marine Drive, Siddhivinayak Temple, Juhu Beach, and more. With professional chauffeurs, flexible itineraries, and transparent pricing, we make your Mumbai sightseeing experience smooth and memorable. Choose Prince Cabs’ trusted Mumbai Darshan cab service for reliability, comfort, and convenience.',

        top: 'Top Places to Visit in Mumbai with Prince Cabs',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924, is Mumbai’s most iconic monument overlooking the Arabian Sea. Constructed in Indo-Saracenic style, it commemorates the visit of King George V and Queen Mary. Today, it is a bustling hub with tourists, photographers, and ferry rides to Elephanta Caves. The monument looks magical at sunset and when illuminated at night. It remains the proud symbol of South Mumbai. Gateway of India is the city’s historic and cultural centerpiece."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, also called the Queen’s Necklace, is a 3.6 km long seafront promenade. Its curved road lit up at night resembles a glittering necklace. Locals and tourists love it for evening walks, jogging, and sea views. During monsoon, crashing waves create dramatic scenes. Sunsets here are breathtaking and romantic. Marine Drive is Mumbai’s favorite leisure hub."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "CST, formerly Victoria Terminus, is a UNESCO World Heritage Site and Mumbai’s busiest railway station. Built in 1887, it features Gothic Revival architecture with domes, spires, and stained-glass windows. The structure glows beautifully when lit at night. It serves millions of commuters daily, blending history with modern life. Tourists admire its grand design while experiencing Mumbai’s lifeline—the local trains. CST is a masterpiece of heritage architecture."
  },
  {
    "title": "Elephanta Caves",
    "description": "Elephanta Caves, located on Elephanta Island, are ancient UNESCO-listed rock-cut temples. Dating back to the 5th–6th centuries, the caves are dedicated to Lord Shiva. The Trimurti sculpture is the highlight, showcasing remarkable craftsmanship. Accessible by ferry from Gateway of India, the island offers peace and greenery. It is a perfect escape from the city rush. Elephanta Caves reflect India’s cultural and artistic legacy."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is Mumbai’s most popular beach, famous for street food and Bollywood connections. Visitors enjoy pav bhaji, bhel puri, and ice gola while walking along the sand. Families gather here in the evenings for leisure and sea breezes. The area is surrounded by luxury hotels and celebrity residences. Sunsets at Juhu are magical. It is the best place to experience Mumbai’s coastal charm."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple in Prabhadevi is Mumbai’s most revered shrine dedicated to Lord Ganesha. Built in 1801, it draws thousands of devotees, including celebrities and politicians. The golden dome and intricately carved doors add grandeur. Tuesdays witness the largest gatherings. Devotees believe prayers here are always fulfilled. Siddhivinayak is the spiritual heart of Mumbai."
  },
  {
    "title": "Bandra–Worli Sea Link",
    "description": "The Bandra–Worli Sea Link is an eight-lane cable-stayed bridge and a marvel of modern engineering. It connects South Mumbai to the western suburbs. Driving across the bridge offers stunning views of the Arabian Sea. At night, its illuminated structure looks spectacular. It has reduced travel time significantly for daily commuters. The Sea Link is a modern icon of Mumbai’s progress."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah, built in the 15th century, is a revered shrine located on an islet in the Arabian Sea. Dedicated to Sufi saint Pir Haji Ali Shah Bukhari, it is visited by devotees of all faiths. The Indo-Islamic architecture stands beautifully against the sea backdrop. Accessible via a narrow causeway during low tide, it creates a unique experience. The shrine offers peace and blessings. Haji Ali is Mumbai’s landmark of spirituality and unity."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is Mumbai’s most famous shopping street, buzzing with shops and street vendors. It offers everything from handicrafts and clothes to jewelry and antiques. Iconic cafés like Leopold Café and Café Mondegar add to its charm. Bargaining with vendors is part of the fun. The area is always crowded with locals and tourists. Colaba reflects Mumbai’s vibrant and cosmopolitan spirit."
  },
  {
    "title": "Girgaon Chowpatty",
    "description": "Girgaon Chowpatty is a lively beach in South Mumbai, famous for Ganesh Visarjan celebrations. It is a hotspot for local snacks like pav bhaji, kulfi, and bhel puri. Families and children enjoy the festive vibe in the evenings. Festivals and fairs make it even more colorful. The beach also offers views of Marine Drive. Chowpatty blends leisure, tradition, and culture in one place."
  },
  {
    "title": "Film City, Goregaon",
    "description": "Film City is the beating heart of Bollywood, spread across 500 acres in Goregaon. It has multiple studios, artificial sets, and shooting zones. Guided tours let visitors witness behind-the-scenes of movie-making. Many films and TV shows are shot here daily. It is one of the largest film production complexes in the world. Film City defines Mumbai’s role as India’s entertainment capital."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "Sanjay Gandhi National Park is a massive green sanctuary within Mumbai, spread over 87 sq. km. It is home to leopards, deer, and hundreds of bird species. Inside the park, the Kanheri Caves display Buddhist monasteries and stupas dating back to the 1st century BC. Visitors enjoy safaris, toy train rides, and trekking trails. It is rare to find such nature inside a metro city. The park is a blend of history, adventure, and wildlife."
  },
  {
    "title": "Powai Lake",
    "description": "Powai Lake is an artificial lake surrounded by lush greenery and modern skyscrapers. It is popular among birdwatchers, with sightings of kingfishers, herons, and migratory birds. Locals enjoy walking and jogging along its promenade. During monsoon, the lake looks especially scenic with misty views. Families visit for picnics and photography. Powai Lake offers calm in the heart of Mumbai."
  },
  {
    "title": "Global Vipassana Pagoda",
    "description": "The Global Vipassana Pagoda near Gorai is one of the largest meditation domes in the world. Built in Burmese style, it houses sacred relics of Buddha. The golden dome can accommodate thousands of meditators. Visitors attend sessions and admire the stunning design. Its seaside location adds serenity and peace. The pagoda symbolizes spirituality and mindfulness."
  },
  {
    "title": "Nehru Planetarium & Science Centre",
    "description": "Nehru Planetarium in Worli is a hub for astronomy and science enthusiasts. It hosts sky shows that explain stars, planets, and galaxies in an engaging way. The adjoining Science Centre has interactive exhibits on technology and space. Students and families love its educational yet fun atmosphere. Special events during eclipses and celestial activities attract crowds. It inspires curiosity and knowledge about space."
  }
],


    "services": [
    {
      "name": "Mumbai Darshan Cab Booking",
      "description": "Book reliable and comfortable Mumbai Darshan cabs for an enjoyable city tour experience. Our service ensures timely pickups, clean vehicles, and professional drivers familiar with all popular tourist spots in Mumbai."
    },
    {
      "name": "Mumbai City Tour Cabs",
      "description": "Explore Mumbai’s iconic landmarks and hidden gems with our Mumbai City Tour Cabs. Whether it's a half-day or full-day tour, travel in comfort with air-conditioned vehicles and knowledgeable drivers who provide insightful guidance."
    },
    {
      "name": "Mumbai Sightseeing Taxi",
      "description": "Discover Mumbai at your own pace with our sightseeing taxi service. Flexible itineraries and affordable rates make it perfect for families, solo travelers, and groups wanting to cover key attractions across the city."
    },
    {
      "name": "Mumbai Darshan Innova",
      "description": "Enjoy a spacious and comfortable Mumbai Darshan experience in an Innova. Ideal for families and groups, the Innova offers ample legroom and luggage space with AC comfort for a pleasant city tour."
    },
    {
      "name": "Mumbai Darshan AC Cab",
      "description": "Travel around Mumbai in a fully air-conditioned cab ensuring a cool and relaxing journey throughout your sightseeing tour. Perfect for hot days and long hours of travel in the city."
    },
    {
      "name": "Full Day Mumbai Tour Taxi",
      "description": "Book a full-day Mumbai tour taxi to cover all major attractions including Gateway of India, Marine Drive, Elephanta Caves, and more. Enjoy flexible stops, comfortable seating, and experienced drivers for a memorable day out."
    },
    {
      "name": "Dzire for Mumbai Darshan",
      "description": "Choose a budget-friendly Dzire sedan for your Mumbai Darshan cab. This compact, fuel-efficient vehicle is perfect for solo travelers or small families looking for an affordable city tour option."
    },
    {
      "name": "Mumbai Local Tour by Cab",
      "description": "Experience Mumbai’s vibrant local culture with our local tour cab service. Visit markets, beaches, historical sites, and famous eateries with a driver who knows the best local spots."
    },
    {
      "name": "Mumbai Darshan Crysta Rental",
      "description": "Upgrade your city tour with an Innova Crysta rental for Mumbai Darshan. Enjoy premium interiors, advanced suspension, and ample space for a luxurious sightseeing experience."
    },
    {
      "name": "Etios Cab Mumbai Darshan",
      "description": "Opt for the Etios cab for your Mumbai Darshan to enjoy a comfortable, air-conditioned ride in a reliable sedan. Ideal for smaller groups or individuals wanting a smooth city tour."
    },
    {
      "name": "Tempo Traveller for Mumbai Darshan",
      "description": "Travel with larger groups comfortably in a Tempo Traveller for Mumbai Darshan. Spacious seating, luggage capacity, and AC make it perfect for families, friends, or corporate groups."
    },
    {
      "name": "Affordable Mumbai Tour Cab",
      "description": "Get affordable Mumbai tour cab services without compromising on comfort or reliability. Our budget-friendly options are perfect for travelers seeking value-for-money city tours."
    },
    {
      "name": "Family Cab for Mumbai Sightseeing",
      "description": "Travel safely and comfortably with your family in a dedicated family cab for Mumbai sightseeing. Equipped with child-friendly features and courteous drivers, it ensures an enjoyable trip for all ages."
    },
    {
      "name": "Mumbai Darshan SUV Taxi",
      "description": "Choose an SUV taxi for your Mumbai Darshan for added comfort, space, and stability. Perfect for rough roads, longer tours, or travelers with extra luggage."
    },
    {
      "name": "Private Car Mumbai Darshan Booking",
      "description": "Book a private car for your Mumbai Darshan to enjoy personalized routes and schedules. Ideal for those seeking exclusivity, privacy, and flexibility during their city tour."
    }
  ],
  "tableData": [
    ["Mumbai Darshan Cab Booking", "Mumbai City Tour Cabs"],
    ["Mumbai Sightseeing Taxi", "Mumbai Darshan Innova"],
    ["Mumbai Darshan AC Cab", "Full Day Mumbai Tour Taxi"],
    ["Dzire for Mumbai Darshan", "Mumbai Local Tour by Cab"],
    ["Mumbai Darshan Crysta Rental", "Etios Cab Mumbai Darshan"],
    ["Tempo Traveller for Mumbai Darshan", "Affordable Mumbai Tour Cab"],
    ["Family Cab for Mumbai Sightseeing", "Mumbai Darshan SUV Taxi"],
    ["Private Car Mumbai Darshan Booking"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Mumbai Darshan Cab Service",
    "WhyChoosedescription": "Prince Cabs offers dependable and comfortable Mumbai Darshan cab services, perfect for tourists and locals eager to explore Mumbai’s iconic landmarks and cultural hotspots. Our service ensures a well-planned itinerary, timely pickups, and a hassle-free sightseeing experience across the city’s top attractions."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles for Sightseeing",
    "WhyChoosedescription": "Our fleet includes sedans and SUVs like Swift Dzire, Ertiga, and Innova, all well-maintained and equipped with comfortable seating, ample luggage space, and air conditioning to make your Mumbai Darshan journey pleasant and relaxing."
  },
  {
    "WhyChooseheading": "Experienced Drivers Knowledgeable About Mumbai",
    "WhyChoosedescription": "Our professional drivers are well-versed with Mumbai’s roads and popular tourist spots, ensuring efficient navigation, safe driving, and helpful guidance to enhance your sightseeing experience."
  },
  {
    "WhyChooseheading": "Flexible Booking Options Tailored to Your Needs",
    "WhyChoosedescription": "Prince Cabs offers customizable Mumbai Darshan packages, including half-day, full-day, and multi-day tours. Booking is simple via phone, WhatsApp, or online with instant confirmation and flexible cancellation policies."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Our Mumbai Darshan cab pricing is clear and competitive, covering fuel, tolls, driver allowances, and taxes. Multiple secure payment methods are accepted including UPI, credit/debit cards, net banking, and cash."
  },
  {
    "WhyChooseheading": "Sanitized and Well-Maintained Vehicles for Your Safety",
    "WhyChoosedescription": "Each vehicle is thoroughly cleaned and sanitized before every trip. Regular maintenance ensures mechanical reliability and safety features such as seat belts and airbags guarantee passenger protection."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for a Smooth Experience",
    "WhyChoosedescription": "Our dedicated customer care team is available round the clock to assist with bookings, itinerary changes, and any travel-related queries, ensuring your Mumbai Darshan cab experience is smooth and worry-free."
  }
]























    }

const faqData = [
    {
        question: 'Does Prince Cabs offer Mumbai Darshan cab services?',
        answer: 'Yes, Prince Cabs provides convenient and comfortable Mumbai Darshan cab tours to popular tourist spots across Mumbai.',
    },
    {
        question: 'What places are covered in the Mumbai Darshan cab tour?',
        answer: 'Our Mumbai Darshan covers key attractions like Gateway of India, Marine Drive, Haji Ali Dargah, Elephanta Caves, and more.',
    },
    {
        question: 'What types of vehicles are available for Mumbai Darshan tours?',
        answer: 'We offer a range of vehicles including Swift Dzire, Ertiga, Innova, and Tempo Traveller suitable for solo travelers, families, and groups.',
    },
    {
        question: 'How long does a typical Mumbai Darshan cab tour last?',
        answer: 'Mumbai Darshan tours can range from 4 to 8 hours depending on your itinerary and preferences.',
    },
    {
        question: 'Are the cabs sanitized and well-maintained for sightseeing tours?',
        answer: 'Absolutely! All our vehicles are regularly cleaned, sanitized, and serviced to ensure your safety and comfort.',
    },
    {
        question: 'What are the fares for Mumbai Darshan cab services?',
        answer: 'Fares vary based on vehicle type, duration, and stops. Please contact Prince Cabs for a personalized quote.',
    },
    {
        question: 'How do I book a Mumbai Darshan cab tour?',
        answer: 'You can easily book through our website or by calling our customer support to customize your Mumbai Darshan experience.',
    },
];

const testimonials = [
    {
        name: "Mr. Arjun Mehta",
        position: "Tourist",
        text: "The Mumbai Darshan cab tour by Prince Cabs was fantastic. The driver was knowledgeable and the vehicle was comfortable.",
        image: "/img/testimonial/testimonial-thumb-mumbai-darshan-1.png",
    },
    {
        name: "Ms. Ritu Sharma",
        position: "Family Traveler",
        text: "Our Mumbai sightseeing trip was smooth and enjoyable with Prince Cabs. Highly recommend their Mumbai Darshan service.",
        image: "/img/testimonial/testimonial-thumb-mumbai-darshan-2.png",
    },
];




















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "TouristTrip",
  "name": "Mumbai Darshan Cabs",
  "description": "Book affordable Mumbai Darshan cab services including Innova, Dzire, Crysta, Etios, Tempo Traveller, and SUV for full-day Mumbai sightseeing tours with AC comfort and family-friendly options.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Prince Cabs",
    "telephone": "+91-XXXXXXXXXX",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Mumbai",
      "addressRegion": "Maharashtra",
      "addressCountry": "IN"
    }
  },
  "touristType": "Sightseeing",
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Mumbai Darshan Cab Types",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Mumbai Darshan Innova"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Mumbai Darshan AC Cab"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Dzire for Mumbai Darshan"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Mumbai Darshan Crysta Rental"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Etios Cab Mumbai Darshan"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Tempo Traveller for Mumbai Darshan"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Mumbai Darshan SUV Taxi"
        }
      }
    ]
  },
  "areaServed": {
    "@type": "City",
    "name": "Mumbai"
  }
};





    return (
        <div>
<Helmet>
  <title>Mumbai Darshan Cabs | Mumbai City Tour & Sightseeing Taxi Service</title>
  <meta
    name="description"
    content="Book affordable Mumbai Darshan cab services including Innova, Dzire, Crysta, Etios, Tempo Traveller, and SUV for full-day Mumbai sightseeing tours with AC comfort and family-friendly options."
  />
  <meta
    name="keywords"
    content="Mumbai Darshan Cab Booking, Mumbai City Tour Cabs, Mumbai Sightseeing Taxi, Mumbai Darshan Innova, Mumbai Darshan AC Cab, Full Day Mumbai Tour Taxi, Dzire for Mumbai Darshan, Mumbai Local Tour by Cab, Mumbai Darshan Crysta Rental, Etios Cab Mumbai Darshan, Tempo Traveller for Mumbai Darshan, Affordable Mumbai Tour Cab, Family Cab for Mumbai Sightseeing, Mumbai Darshan SUV Taxi, Private Car Mumbai Darshan Booking"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/80.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaidarshancabs ;